import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { Alert } from 'antd'
import { accountProblems } from './utils'

// Where a problem is fixed. Everything but the price is a server setting explained on the ShipsGo
// account page; the price has its own.
const PROBLEM_LINKS = {
  no_price: { to: '/tracking/pricing', label: 'Pricing' }
}
const ACCOUNT_LINK = { to: '/tracking/account', label: 'ShipsGo account' }

// The setup mistakes that stop tracking being sold or started, on every page the team actually
// opens — not only on the setup page nobody visits. `accountProblems` decides what is wrong; this
// only renders it and says where to go.
const AccountBanner = ({ account, pricing }) => {
  const problems = accountProblems(account, pricing)
  if (!problems.length) return null

  return (
    <div>
      {problems.map(problem => {
        const link = PROBLEM_LINKS[problem.key] || ACCOUNT_LINK
        return (
          <Alert
            key={problem.key}
            type={problem.level}
            showIcon
            style={{ marginBottom: 12 }}
            message={problem.message}
            action={<Link to={link.to}>{link.label}</Link>}
          />
        )
      })}
    </div>
  )
}

AccountBanner.propTypes = {
  account: PropTypes.object,
  pricing: PropTypes.object
}

export default AccountBanner
